import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { useCan } from "@/lib/policy";
import { searchPatch, optionalSearch } from "@/lib/search";
import { FaxContactsPanel } from "./-components/messaging/fax-contacts-panel";
import { FaxNumbersPanel } from "./-components/messaging/fax-numbers-panel";
import { FaxProviderCard } from "./-components/messaging/fax-provider-card";

export const Route = createFileRoute("/_authenticated/_administration/settings/fax")({
  validateSearch: (search: Record<string, unknown>): { q?: string } => ({
    q: optionalSearch(search.q),
  }),
  beforeLoad: ({ context }) => guardRoute(context.me, "fax-settings"),
  component: FaxSettings,
});

/** Three panels: owned numbers and who is told, who the building sends paper to, and which layer
 * the provider credentials come from. */
function FaxSettings() {
  const canManagePlatform = useCan("platform:manage");
  const { q } = Route.useSearch();
  const patch = searchPatch(useNavigate({ from: Route.fullPath }));

  return (
    <>
      <PageHeader
        title="Fax"
        meta="The fax numbers your buildings send and receive on, and the address book staff fax from."
      />
      <FaxNumbersPanel />
      <FaxContactsPanel q={q} onQ={(next) => patch({ q: next })} />
      {canManagePlatform ? <FaxProviderCard /> : null}
    </>
  );
}
